type GuardValidator<T> = (value: unknown) => value is T;

export default function isOptional<T = unknown>(validate: GuardValidator<T>, value: unknown): value is T | undefined {
  return value === undefined || validate(value);
}

export function createOptionalGuard<T>(validate: GuardValidator<T>): GuardValidator<T | undefined> {
  return isOptional.bind(undefined, validate) as GuardValidator<T>;
}
